import { render, staticRenderFns } from "./asNuToReg.vue?vue&type=template&id=8d3a0048&scoped=true&"
import script from "./asNuToReg.vue?vue&type=script&lang=js&"
export * from "./asNuToReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3a0048",
  null
  
)

export default component.exports